<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="21.164"><path d="M8.616 1.537l-.771.857L4.4 6.226l-.809.9-.857-.857L.818 4.353 0 3.539l1.628-1.624.814.809L3.5 3.784 6.139.853 6.91.001l1.71 1.537zm0 7.663l-.771.852L4.4 13.884l-.809.905-.857-.857-1.916-1.916L0 11.2l1.628-1.624.814.814L3.5 11.451 6.14 8.52l.771-.852 1.71 1.537zm2.591-7.193H25v3.065H11.207zm0 7.663H25v3.065H11.207zm-3.065 7.663H25V20.4H8.142zm-5.364-.766a2.3 2.3 0 0 1 2.3 2.3 2.3 2.3 0 0 1-2.3 2.3 2.3 2.3 0 0 1-2.3-2.3 2.3 2.3 0 0 1 2.3-2.3z"/></svg>
</template>

<script>
	export default {
		name: "List"
	}
</script>